/**
 * Newsletter block — entrance animation.
 *
 * On load each block is "armed": its overlay and content start hidden (the CSS
 * for this only applies once .is-armed is present, so visitors without JS keep
 * seeing everything). An IntersectionObserver then adds .is-visible when the
 * block scrolls into view, which triggers the CSS transition: the background
 * blur/scrim overlay fades in first, then the form + contact content fades in
 * and slides up from the bottom (the stagger is handled by transition-delay).
 */
export function initNewsletter() {
    const blocks = document.querySelectorAll('.block-newsletter');
    if (!blocks.length) return;

    blocks.forEach((block) => block.classList.add('is-armed'));

    if (!('IntersectionObserver' in window)) {
        blocks.forEach((block) => block.classList.add('is-visible'));
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
        });
    }, { threshold: 0.2 });

    blocks.forEach((block) => observer.observe(block));
}
